module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/cooking/chef-378ac2ce11e96ef68eef29eff2aea19e.svg";